/**
 * Keep a decoded branding logo URL across soft-refetch HMAC remints (same galleryVersion).
 */

import { useState } from 'react';
import {
  brandingSignedMediaIdentity,
  preferStableBrandingMediaUrl,
} from './signedMediaUrlStability.js';

export function useStableBrandingLogoSrc(
  logoSrc: string | null,
): {
  readonly displaySrc: string | null;
  readonly displayKey: string | null;
} {
  const [displaySrc, setDisplaySrc] = useState<string | null>(logoSrc);
  const nextSrc = preferStableBrandingMediaUrl(displaySrc, logoSrc);
  if (nextSrc !== displaySrc) {
    setDisplaySrc(nextSrc);
  }

  return {
    displaySrc: nextSrc,
    displayKey: brandingSignedMediaIdentity(nextSrc),
  };
}
